module.exports = __webpack_public_path__ + "img/10.ce487e0f.png";